import { base } from '@/app/editor/sidebar/constant';
import type { editor } from './types';
import { mutationTypes } from './types';
import type { MutationTree } from 'vuex';

const mutations: MutationTree<editor> = {
  [mutationTypes.SET_BEFORE_STYLE_PREVIEW_MODE](_state: editor, payload: any) {
    if (payload.value) {
      _state.beforeStylePreviewModeGlobalStyle[payload.id] = payload.value;
    }
  },

  [mutationTypes.SET_DATA_SETTINGS](_state: editor, payload: any) {
    if (payload.value) {
      _state.dataSettings[payload.id] = payload.value;
    }
  },

  [mutationTypes.SET_ANIMATION_DATA_SETTINGS](_state: editor, payload: any) {
    if (!payload || !payload.type) return;
    if (payload.value) {
      if (payload.type == 'action') {
        _state.animations.actions[payload.id] = payload.value;
      } else {
        _state.animations.interactions[payload.id] = payload.value;
      }
    }
  },

  [mutationTypes.SET_DATA_SNIPPETS](_state: editor, payload: any) {
    _state.dataSnippets[payload.key] = payload.value;
  },

  [mutationTypes.SET_ALL_DATA_SNIPPETS](_state: editor, payload: any) {
    _state.dataSnippets = payload;
  },

  [mutationTypes.DELETE_ANIMATION_DATA_SETTING](_state: editor, payload: any) {
    if (_state.animations && payload) {
      if (payload.type == 'action') {
        delete _state.animations.actions[payload.key];
      } else {
        delete _state.animations.interactions[payload.key];
      }
    }
  },

  [mutationTypes.DELETE_DATA_SETTING_BY_KEY](_state: editor, payload: any) {
    if (_state.dataSettings) {
      Object.keys(base).map(function (key) {
        const baseKey = (base as any)[key];
        if (payload.data[baseKey]) {
          const keyItem = baseKey + '-' + payload.keyType + '-' + payload.attrId;
          if (payload.attrId) {
            delete _state.dataSettings[payload.attrId];
          }

          if (_state.dataSettings[keyItem]) {
            delete _state.dataSettings[keyItem];
          }
        }
      });
    }
    return false;
  },

  [mutationTypes.SHOW_SHORTCUT_MODAL](state: editor, isShow = false) {
    state.showShortcutModal = isShow;
  },
  [mutationTypes.SET_LOADING_DYNAMIC_DATA](_state: editor, isLoading = false) {
    _state.isLoadingDynamicData = isLoading;
  },
  [mutationTypes.SET_LOADING_EDITOR](_state: editor, isLoading = false) {
    _state.isLoadingEditor = isLoading;
  },
  [mutationTypes.SET_TYPE_BLANK_PAGE](_state: editor, isBlankPage = false) {
    _state.isBlankPage = isBlankPage;
  },
};

export default mutations;
